import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';
import { CreateMode } from '../utils/create.utils';

export const setMode = action(
  '[Create] setMode',
  props<{ mode: CreateMode } & SkipHistory>(),
);

export const unsetMode = action('[Create] unsetMode', props<SkipHistory>());

export const setLeads = action(
  '[Create] setLeads',
  props<{ leads: string[] } & SkipHistory>(),
);
